import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import form_data from "./formData";


const ReactWebSiteApi = createApi({
    reducerPath: 'ReactWebSiteApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/ReactWebSite'        
    }),
    tagTypes:[],
    endpoints(build) {
        return{   
            //商品订单列表
            getqiyedingdan: build.query({
                query(user) {
                    return {
                        url: '/getqiyedingdan',
                        method: 'post',
                        body: form_data(user)
                    }
                },
            }),      
           
        }
    }
})
export const {
    useGetqiyedingdanQuery,
    useLazyGetqiyedingdanQuery,
} = ReactWebSiteApi;
export default ReactWebSiteApi;